module.exports = __webpack_public_path__ + "static/media/3.908eb576.jpg";